// import React, { useState } from "react";
// import "./MyAccount.css";

// const Wishlist = () => {
//   const [wishlistItems, setWishlistItems] = useState([
//     {
//       id: 1,
//       name: "Baby Cotton Romper",
//       price: 599,
//       originalPrice: 799,
//       image:
//         "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400",
//       available: true,
//       inStock: true,
//       size: "6-12M",
//       color: "Pink",
//     },
//     {
//       id: 2,
//       name: "Girls Floral Dress",
//       price: 899,
//       originalPrice: 1199,
//       image:
//         "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=400",
//       available: true,
//       inStock: true,
//       size: "4-5Y",
//       color: "Floral",
//     },
//     {
//       id: 3,
//       name: "Boys Denim Jacket",
//       price: 1299,
//       originalPrice: 1599,
//       image:
//         "https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=400",
//       available: false,
//       inStock: false,
//       size: "6-7Y",
//       color: "Blue Denim",
//     },
//     {
//       id: 4,
//       name: "Organic Baby Blanket",
//       price: 799,
//       originalPrice: 999,
//       image:
//         "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400",
//       available: true,
//       inStock: false,
//       size: "Standard",
//       color: "Cream",
//     },
//     {
//       id: 5,
//       name: "Newborn Cap Set",
//       price: 299,
//       originalPrice: 399,
//       image:
//         "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400",
//       available: true,
//       inStock: true,
//       size: "0-6M",
//       color: "Blue",
//     },
//     {
//       id: 6,
//       name: "Soft Toys Set",
//       price: 499,
//       originalPrice: 699,
//       image:
//         "https://images.unsplash.com/photo-1514090458221-65bb69cf63e6?w=400",
//       available: false,
//       inStock: false,
//       size: "Medium",
//       color: "Multi",
//     },
//   ]);

//   const handleRemoveItem = (id) => {
//     if (window.confirm("Remove this item from wishlist?")) {
//       setWishlistItems(wishlistItems.filter((item) => item.id !== id));
//     }
//   };

//   const handleAddToCart = (item) => {
//     console.log("Adding to cart:", item);
//     // Add your cart logic here
//     alert(`${item.name} added to cart!`);
//   };

//   const handleNotifyMe = (item) => {
//     console.log("Notify me:", item);
//     // Add your notification logic here
//     alert(`We'll notify you when ${item.name} is back in stock!`);
//   };

//   return (
//     <div className="wishlist-section">
//       <div className="section-header">
//         <div>
//           <h2 className="section-title">My Wishlist</h2>
//           <p className="section-subtitle">
//             {wishlistItems.length}{" "}
//             {wishlistItems.length === 1 ? "item" : "items"} saved
//           </p>
//         </div>
//       </div>

//       {wishlistItems.length > 0 ? (
//         <div className="wishlist-grid">
//           {wishlistItems.map((item) => (
//             <div key={item.id} className="wishlist-card">
//               {/* Availability Badge */}
//               {!item.available && (
//                 <div className="availability-badge not-available">
//                   Not Available
//                 </div>
//               )}
//               {item.available && !item.inStock && (
//                 <div className="availability-badge out-of-stock">
//                   Out of Stock
//                 </div>
//               )}

//               {/* Remove Button */}
//               <button
//                 className="remove-wishlist-btn"
//                 onClick={() => handleRemoveItem(item.id)}
//               >
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <line x1="18" y1="6" x2="6" y2="18" />
//                   <line x1="6" y1="6" x2="18" y2="18" />
//                 </svg>
//               </button>

//               {/* Product Image */}
//               <div className="wishlist-image-container">
//                 <img
//                   src={item.image}
//                   alt={item.name}
//                   className={`wishlist-image ${
//                     !item.available ? "unavailable" : ""
//                   }`}
//                 />
//               </div>

//               {/* Product Details */}
//               <div className="wishlist-details">
//                 <h3 className="wishlist-item-name">{item.name}</h3>
//                 <div className="wishlist-item-meta">
//                   <span>Size: {item.size}</span>
//                   <span>•</span>
//                   <span>Color: {item.color}</span>
//                 </div>
//                 <div className="wishlist-price">
//                   <span className="current-price">₹{item.price}</span>
//                   {item.originalPrice > item.price && (
//                     <span className="original-price">
//                       ₹{item.originalPrice}
//                     </span>
//                   )}
//                   {item.originalPrice > item.price && (
//                     <span className="discount">
//                       {Math.round(
//                         ((item.originalPrice - item.price) /
//                           item.originalPrice) *
//                           100
//                       )}
//                       % OFF
//                     </span>
//                   )}
//                 </div>

//                 {/* Action Buttons */}
//                 <div className="wishlist-actions">
//                   {item.available && item.inStock ? (
//                     <button
//                       className="btn-primary wishlist-btn"
//                       onClick={() => handleAddToCart(item)}
//                     >
//                       <svg
//                         width="18"
//                         height="18"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                       >
//                         <circle cx="9" cy="21" r="1" />
//                         <circle cx="20" cy="21" r="1" />
//                         <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
//                       </svg>
//                       Add to Cart
//                     </button>
//                   ) : item.available && !item.inStock ? (
//                     <button
//                       className="btn-secondary wishlist-btn"
//                       onClick={() => handleNotifyMe(item)}
//                     >
//                       <svg
//                         width="18"
//                         height="18"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                       >
//                         <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
//                         <path d="M13.73 21a2 2 0 0 1-3.46 0" />
//                       </svg>
//                       Notify Me
//                     </button>
//                   ) : (
//                     <button className="btn-disabled wishlist-btn" disabled>
//                       <svg
//                         width="18"
//                         height="18"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                       >
//                         <circle cx="12" cy="12" r="10" />
//                         <line x1="15" y1="9" x2="9" y2="15" />
//                         <line x1="9" y1="9" x2="15" y2="15" />
//                       </svg>
//                       Not Available
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="empty-wishlist">
//           <svg
//             width="100"
//             height="100"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="1.5"
//           >
//             <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
//           </svg>
//           <h3>Your wishlist is empty</h3>
//           <p>Save items you love for later!</p>
//           <button className="btn-primary">Continue Shopping</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Wishlist;

import React, { useState, useEffect } from "react";
import wishlistService from "../../services/wishlistService";
import { useNavigate } from "react-router-dom";
import "./MyAccount.css";

const Wishlist = () => {
  const navigate = useNavigate();
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [removingId, setRemovingId] = useState(null);

  useEffect(() => {
    fetchWishlist();
  }, []);

  const fetchWishlist = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await wishlistService.getWishlist();
      setWishlistItems(response.data.data || []);
    } catch (err) {
      console.error("Error fetching wishlist:", err);
      setError(err.response?.data?.message || "Failed to load wishlist");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveItem = async (id) => {
    if (!window.confirm("Remove this item from wishlist?")) {
      return;
    }

    try {
      setRemovingId(id);
      await wishlistService.removeFromWishlist(id);
      setWishlistItems(wishlistItems.filter((item) => item._id !== id));
    } catch (err) {
      console.error("Error removing item:", err);
      alert(err.response?.data?.message || "Failed to remove item");
    } finally {
      setRemovingId(null);
    }
  };

  const handleAddToCart = async (item) => {
    try {
      // Move to cart (this will also remove from wishlist)
      await wishlistService.moveToCart(item._id, 1);

      // Remove from local state
      setWishlistItems(wishlistItems.filter((i) => i._id !== item._id));

      alert(`${item.name} added to cart!`);

      // Optionally redirect to cart
      // navigate('/cart');
    } catch (err) {
      console.error("Error adding to cart:", err);
      alert(err.response?.data?.message || "Failed to add to cart");
    }
  };

  const handleNotifyMe = async (item) => {
    try {
      await wishlistService.toggleNotify(item._id);

      // Update local state
      setWishlistItems(
        wishlistItems.map((i) =>
          i._id === item._id ? { ...i, notifyOnStock: !i.notifyOnStock } : i
        )
      );

      const message = !item.notifyOnStock
        ? `We'll notify you when ${item.name} is back in stock!`
        : "Notification disabled";

      alert(message);
    } catch (err) {
      console.error("Error toggling notification:", err);
      alert("Failed to update notification preference");
    }
  };

  const handleClearWishlist = async () => {
    if (
      !window.confirm("Are you sure you want to clear your entire wishlist?")
    ) {
      return;
    }

    try {
      await wishlistService.clearWishlist();
      setWishlistItems([]);
      alert("Wishlist cleared successfully");
    } catch (err) {
      console.error("Error clearing wishlist:", err);
      alert("Failed to clear wishlist");
    }
  };

  if (loading) {
    return (
      <div className="wishlist-section">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading your wishlist...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="wishlist-section">
        <div className="error-container">
          <svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ef5350"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <h3>Error loading wishlist</h3>
          <p>{error}</p>
          <button className="btn-primary" onClick={fetchWishlist}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="wishlist-section">
      <div className="section-header">
        <div>
          <h2 className="section-title">My Wishlist</h2>
          <p className="section-subtitle">
            {wishlistItems.length}{" "}
            {wishlistItems.length === 1 ? "item" : "items"} saved
          </p>
        </div>
        {wishlistItems.length > 0 && (
          <button className="btn-danger" onClick={handleClearWishlist}>
            Clear All
          </button>
        )}
      </div>

      {wishlistItems.length > 0 ? (
        <div className="wishlist-grid">
          {wishlistItems.map((item) => (
            <div
              key={item._id}
              className={`wishlist-card ${
                removingId === item._id ? "removing" : ""
              }`}
            >
              {/* Availability Badge */}
              {!item.available && (
                <div className="availability-badge not-available">
                  Not Available
                </div>
              )}
              {item.available && !item.inStock && (
                <div className="availability-badge out-of-stock">
                  Out of Stock
                </div>
              )}

              {/* Remove Button */}
              <button
                className="remove-wishlist-btn"
                onClick={() => handleRemoveItem(item._id)}
                disabled={removingId === item._id}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>

              {/* Product Image */}
              <div className="wishlist-image-container">
                <img
                  src={item.image}
                  alt={item.name}
                  className={`wishlist-image ${
                    !item.available ? "unavailable" : ""
                  }`}
                  onError={(e) => {
                    e.target.src = "/placeholder-image.jpg";
                  }}
                />
              </div>

              {/* Product Details */}
              <div className="wishlist-details">
                <h3 className="wishlist-item-name">{item.name}</h3>
                {(item.size || item.color) && (
                  <div className="wishlist-item-meta">
                    {item.size && <span>Size: {item.size}</span>}
                    {item.size && item.color && <span>•</span>}
                    {item.color && <span>Color: {item.color}</span>}
                  </div>
                )}
                <div className="wishlist-price">
                  <span className="current-price">₹{item.price}</span>
                  {item.originalPrice && item.originalPrice > item.price && (
                    <>
                      <span className="original-price">
                        ₹{item.originalPrice}
                      </span>
                      <span className="discount">
                        {Math.round(
                          ((item.originalPrice - item.price) /
                            item.originalPrice) *
                            100
                        )}
                        % OFF
                      </span>
                    </>
                  )}
                </div>

                {/* Action Buttons */}
                <div className="wishlist-actions">
                  {item.available && item.inStock ? (
                    <button
                      className="btn-primary wishlist-btn"
                      onClick={() => handleAddToCart(item)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <circle cx="9" cy="21" r="1" />
                        <circle cx="20" cy="21" r="1" />
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                      </svg>
                      Add to Cart
                    </button>
                  ) : item.available && !item.inStock ? (
                    <button
                      className={`btn-secondary wishlist-btn ${
                        item.notifyOnStock ? "notify-active" : ""
                      }`}
                      onClick={() => handleNotifyMe(item)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill={item.notifyOnStock ? "currentColor" : "none"}
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                      </svg>
                      {item.notifyOnStock ? "Notifications On" : "Notify Me"}
                    </button>
                  ) : (
                    <button className="btn-disabled wishlist-btn" disabled>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <line x1="15" y1="9" x2="9" y2="15" />
                        <line x1="9" y1="9" x2="15" y2="15" />
                      </svg>
                      Not Available
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-wishlist">
          <svg
            width="100"
            height="100"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
          <h3>Your wishlist is empty</h3>
          <p>Save items you love for later!</p>
          <button className="btn-primary" onClick={() => navigate("/")}>
            Continue Shopping
          </button>
        </div>
      )}
    </div>
  );
};

export default Wishlist;
